import { Check } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import CtaBanner from "@/components/CtaBanner";
import { SERVICES } from "@/constants/site";

export default function Servizi() {
  return (
    <main data-testid="servizi-page">
      <section className="bg-[#F7F5F0] pb-20 pt-36 sm:pt-44">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <Overline>Servizi</Overline>
            <h1 className="mt-4 max-w-2xl font-serif text-4xl font-semibold tracking-tight text-[#1A1918] sm:text-5xl lg:text-6xl">
              Ogni ambiente,
              <span className="italic text-[#C85A32]"> rifatto a regola d'arte.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#6E6A64] md:text-lg">
              Dalla singola stanza all'intero appartamento: progettiamo,
              coordiniamo e realizziamo tutto con maestranze interne.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee />

      <section className="bg-[#F7F5F0] py-20 sm:py-28">
        <div className="mx-auto max-w-7xl space-y-24 px-5 sm:px-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id}>
              <article
                data-testid={`servizi-detail-${s.id}`}
                className={`grid items-center gap-10 lg:grid-cols-2 ${
                  i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="overflow-hidden rounded-b-2xl rounded-t-[8rem]">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105 sm:aspect-[5/5]"
                  />
                </div>
                <div>
                  <p className="font-mono text-sm text-[#B88E4C]">0{i + 1}</p>
                  <h2 className="mt-3 font-serif text-2xl font-semibold tracking-tight text-[#1A1918] sm:text-3xl lg:text-4xl">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-base leading-relaxed text-[#6E6A64] md:text-lg">
                    {s.short}
                  </p>
                  <ul className="mt-8 space-y-3.5">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-sm text-[#1A1918]/85">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#C85A32]/15 text-[#C85A32]">
                          <Check size={12} strokeWidth={3} />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                  <p className="mt-8 border-l-2 border-[#B88E4C] pl-4 text-sm italic leading-relaxed text-[#6E6A64]">
                    Preventivo dettagliato e gratuito dopo il sopralluogo, senza
                    impegno.
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBanner />
    </main>
  );
}
